<ion-toolbar color="primary">
  <!-- Heading nativo (ion-title non lo è e tronca i testi lunghi): tabindex=-1, il focus lo riceve da codice. -->
  <h1 #titolo id="collegamento-titolo" tabindex="-1" class="titolo">
    {{ 'auth.collegamento.titolo.' + vista() | transloco: {provider: provider()} }}
  </h1>
</ion-toolbar>

<ion-content class="ion-padding">
  <!-- Regione di stato sempre presente nel DOM: annuncia l'avanzamento di collegamento e invio. -->
  <div class="sr-only" role="status" aria-live="polite" aria-atomic="true">{{ messaggioProgresso() }}</div>

  <!-- Email mascherata: gli asterischi sono nascosti allo screen reader, che legge solo il dominio. -->
  <ng-template #emailMascherataTpl>
    @if (emailMascherata(); as email) {
      <span aria-hidden="true">{{ email }}</span>
      <span class="sr-only">
        @if (dominioEmail(); as dominio) {
          {{ 'auth.collegamento.dati.emailNascostaSr' | transloco: {dominio: dominio} }}
        } @else {
          {{ 'auth.collegamento.dati.emailNascostaSrGenerica' | transloco }}
        }
      </span>
    } @else {
      {{ 'auth.collegamento.dati.emailAssente' | transloco }}
    }
  </ng-template>

  <div class="contenuto">
    @switch (vista()) {

      <!-- S0 -->
      @case ('iniziale') {
        <p id="collegamento-descrizione">{{ 'auth.collegamento.iniziale.testo' | transloco: {provider: provider()} }}</p>
        <dl class="dati">
          <div>
            <dt>{{ 'auth.collegamento.dati.nome' | transloco }}</dt>
            <dd>{{ statoRisposta()?.account?.nome }}</dd>
          </div>
          <div>
            <dt>{{ 'auth.collegamento.dati.cognome' | transloco }}</dt>
            <dd>{{ statoRisposta()?.account?.cognome }}</dd>
          </div>
          <div>
            <dt>{{ 'auth.collegamento.dati.email' | transloco }}</dt>
            <dd>
              <ng-container [ngTemplateOutlet]="emailMascherataTpl"></ng-container>
            </dd>
          </div>
        </dl>
        <p class="domanda">{{ 'auth.collegamento.iniziale.domanda' | transloco }}</p>
        <ion-button expand="block" color="primary" fill="solid" (click)="vai('conferma')">
          {{ 'auth.collegamento.azioni.siMio' | transloco }}
        </ion-button>
        <ion-button expand="block" color="primary" fill="outline" class="azione-secondaria" (click)="vai('segnalazione')">
          {{ 'auth.collegamento.azioni.noNonSono' | transloco }}
        </ion-button>
        <ion-button expand="block" color="primary" fill="clear" class="azione-link" (click)="chiudi('esci')">
          {{ 'auth.collegamento.azioni.esciSenzaScegliere' | transloco }}
        </ion-button>
      }

      <!-- S1: unica conferma del collegamento (il POST parte solo da "Collega l'account"). -->
      @case ('conferma') {
        <p id="collegamento-descrizione">
          @if (nomeCompleto()) {
            {{ 'auth.collegamento.conferma.testo' | transloco: {provider: provider(), nomeCompleto: nomeCompleto()} }}
          } @else {
            {{ 'auth.collegamento.conferma.testoSenzaNome' | transloco: {provider: provider()} }}
          }
        </p>
        @if (emailMascherata()) {
          <p>
            {{ 'auth.collegamento.conferma.email' | transloco }}
            <ng-container [ngTemplateOutlet]="emailMascherataTpl"></ng-container>
          </p>
        }
        <p>{{ 'auth.collegamento.conferma.password' | transloco }}</p>
        @if (daSegnalazione()) {
          <p id="collegamento-ritiro" class="ritiro">
            @if (riferimento()) {
              {{ 'auth.collegamento.conferma.ritiro' | transloco: {riferimento: riferimento()} }}
            } @else {
              {{ 'auth.collegamento.conferma.ritiroGenerico' | transloco }}
            }
          </p>
        } @else {
          <p>{{ 'auth.collegamento.conferma.avviso' | transloco }}</p>
        }
        <ion-button expand="block" color="primary" fill="solid" (click)="collega()">
          {{ 'auth.collegamento.azioni.collega' | transloco }}
        </ion-button>
        <ion-button expand="block" color="primary" fill="outline" class="azione-secondaria" (click)="indietroDaConferma()">
          {{ 'auth.collegamento.azioni.indietro' | transloco }}
        </ion-button>
        <ion-button expand="block" color="primary" fill="clear" class="azione-link" (click)="chiudi('esci')">
          {{ 'auth.collegamento.azioni.esciSenzaScegliere' | transloco }}
        </ion-button>
      }

      <!-- S2: niente pulsanti inutili, solo l'uscita (la chiamata ha comunque un timeout). -->
      @case ('inCorso') {
        <p id="collegamento-descrizione" class="progresso">
          <ion-spinner name="crescent" aria-hidden="true"></ion-spinner>
          <span>{{ 'auth.collegamento.inCorso.testo' | transloco }}</span>
        </p>
        <ion-button expand="block" color="primary" fill="clear" class="azione-link" (click)="chiudi('esci')">
          {{ 'auth.collegamento.azioni.esciSenzaScegliere' | transloco }}
        </ion-button>
      }

      <!-- S4 -->
      @case ('collegato') {
        <p id="collegamento-descrizione">{{ 'auth.collegamento.collegato.testo' | transloco: {provider: provider()} }}</p>
        @if (accountAttivato()) {
          <p>{{ 'auth.collegamento.collegato.attivo' | transloco }}</p>
        }
        <ion-button expand="block" color="primary" fill="solid" (click)="chiudi('riaccedi')">
          {{ 'auth.collegamento.azioni.accedi' | transloco: {provider: provider()} }}
        </ion-button>
        <ion-button expand="block" color="primary" fill="outline" class="azione-secondaria" (click)="chiudi('login')">
          {{ 'auth.collegamento.azioni.paginaAccesso' | transloco }}
        </ion-button>
      }

      <!-- S5: il pulsante di uscita è già quello di esito; il focus va sul titolo, il messaggio è un alert. -->
      @case ('erroreCollegamento') {
        <p id="collegamento-descrizione" class="errore" role="alert">
          {{ 'auth.collegamento.errore.' + tipoErrore() | transloco }}
        </p>
        @if (tipoErrore() === 'nonPossibile') {
          <ion-button expand="block" color="primary" fill="solid" (click)="vai('segnalazione')">
            {{ 'auth.collegamento.azioni.noNonSono' | transloco }}
          </ion-button>
        } @else {
          <ion-button expand="block" color="primary" fill="solid" (click)="riprova()">
            {{ 'auth.collegamento.azioni.riprova' | transloco }}
          </ion-button>
        }
        <ion-button expand="block" color="primary" fill="outline" class="azione-secondaria" (click)="chiudi('esci')">
          {{ 'auth.collegamento.azioni.esci' | transloco }}
        </ion-button>
      }

      <!-- S6 -->
      @case ('segnalazione') {
        <p id="collegamento-descrizione">{{ 'auth.collegamento.segnalazione.testo' | transloco }}</p>
        <p class="nota">{{ 'auth.collegamento.segnalazione.obbligatori' | transloco }}</p>
        @if (erroreInvio(); as chiave) {
          <p class="errore" id="collegamento-errore-invio" tabindex="-1">{{ 'auth.collegamento.' + chiave | transloco }}</p>
        }
        @if (campiDaCorreggere() > 0) {
          <p class="errore" id="collegamento-riepilogo-errori" role="alert">
            {{ 'auth.collegamento.segnalazione.riepilogoErrori.' + (campiDaCorreggere() === 1 ? 'one' : 'other') | transloco: {n: campiDaCorreggere()} }}
          </p>
        }
        <form [formGroup]="form" (ngSubmit)="vaiAlRiepilogo()" novalidate>
          <div class="campo">
            <label for="collegamento-nome">
              {{ 'auth.collegamento.segnalazione.campi.nome' | transloco }}<span aria-hidden="true"> *</span>
            </label>
            <input id="collegamento-nome" data-campo="nome" type="text" formControlName="nome" autocomplete="given-name"
                   aria-required="true" [attr.maxlength]="lunghezzeMax.nome"
                   [attr.aria-invalid]="erroreCampo('nome') ? 'true' : null"
                   [attr.aria-describedby]="descrittori('nome')"/>
            @if (erroreCampo('nome'); as chiave) {
              <div class="field-error" id="collegamento-errore-nome">{{ 'auth.collegamento.' + chiave | transloco: erroreParams('nome') }}</div>
            }
          </div>

          <div class="campo">
            <label for="collegamento-cognome">
              {{ 'auth.collegamento.segnalazione.campi.cognome' | transloco }}<span aria-hidden="true"> *</span>
            </label>
            <input id="collegamento-cognome" data-campo="cognome" type="text" formControlName="cognome" autocomplete="family-name"
                   aria-required="true" [attr.maxlength]="lunghezzeMax.cognome"
                   [attr.aria-invalid]="erroreCampo('cognome') ? 'true' : null"
                   [attr.aria-describedby]="descrittori('cognome')"/>
            @if (erroreCampo('cognome'); as chiave) {
              <div class="field-error" id="collegamento-errore-cognome">{{ 'auth.collegamento.' + chiave | transloco: erroreParams('cognome') }}</div>
            }
          </div>

          <div class="campo">
            <label for="collegamento-telefono">
              {{ 'auth.collegamento.segnalazione.campi.telefono' | transloco }}<span aria-hidden="true"> *</span>
            </label>
            <input id="collegamento-telefono" data-campo="telefono" type="tel" inputmode="tel" formControlName="telefono"
                   autocomplete="tel" aria-required="true"
                   [attr.aria-invalid]="erroreCampo('telefono') ? 'true' : null"
                   [attr.aria-describedby]="descrittori('telefono', 'collegamento-telefono-aiuto')"/>
            <div class="aiuto" id="collegamento-telefono-aiuto">{{ 'auth.collegamento.segnalazione.campi.telefonoAiuto' | transloco }}</div>
            @if (erroreCampo('telefono'); as chiave) {
              <div class="field-error" id="collegamento-errore-telefono">{{ 'auth.collegamento.' + chiave | transloco }}</div>
            }
          </div>

          <div class="campo">
            <label for="collegamento-email">{{ 'auth.collegamento.segnalazione.campi.email' | transloco }}</label>
            <input id="collegamento-email" data-campo="email" type="email" inputmode="email" formControlName="email"
                   autocomplete="email" [attr.maxlength]="lunghezzeMax.email"
                   [attr.aria-invalid]="erroreCampo('email') ? 'true' : null"
                   [attr.aria-describedby]="descrittori('email')"/>
            @if (erroreCampo('email'); as chiave) {
              <div class="field-error" id="collegamento-errore-email">{{ 'auth.collegamento.' + chiave | transloco: erroreParams('email') }}</div>
            }
          </div>

          <div class="campo">
            <label for="collegamento-testo">
              {{ 'auth.collegamento.segnalazione.campi.messaggio' | transloco }}<span aria-hidden="true"> *</span>
            </label>
            <textarea id="collegamento-testo" data-campo="testo" rows="4" formControlName="testo"
                      aria-required="true" [attr.maxlength]="lunghezzeMax.testo"
                      [attr.aria-invalid]="erroreCampo('testo') ? 'true' : null"
                      [attr.aria-describedby]="descrittori('testo', 'collegamento-messaggio-aiuto', 'collegamento-contatore')"></textarea>
            <div class="aiuto" id="collegamento-messaggio-aiuto">{{ 'auth.collegamento.segnalazione.campi.messaggioAiuto' | transloco }}</div>
            <div class="contatore" id="collegamento-contatore">
              {{ 'auth.collegamento.segnalazione.campi.contatore' | transloco: {n: lunghezzaTesto(), max: lunghezzeMax.testo} }}
            </div>
            @if (erroreCampo('testo'); as chiave) {
              <div class="field-error" id="collegamento-errore-testo">{{ 'auth.collegamento.' + chiave | transloco: erroreParams('testo') }}</div>
            }
          </div>

          <ion-button expand="block" color="primary" fill="solid" type="submit">
            {{ 'auth.collegamento.azioni.continua' | transloco }}
          </ion-button>
          <ion-button expand="block" color="primary" fill="outline" class="azione-secondaria" type="button" (click)="vai('iniziale')">
            {{ 'auth.collegamento.azioni.indietro' | transloco }}
          </ion-button>
          <ion-button expand="block" color="primary" fill="clear" class="azione-link" type="button" (click)="chiudi('esci')">
            {{ 'auth.collegamento.azioni.esciSenzaScegliere' | transloco }}
          </ion-button>
        </form>
      }

      <!-- S7 -->
      @case ('riepilogo1') {
        <p id="collegamento-descrizione">{{ 'auth.collegamento.riepilogo.testo' | transloco }}</p>
        <dl class="dati">
          <div>
            <dt>{{ 'auth.collegamento.riepilogo.nome' | transloco }}</dt>
            <dd>{{ riepilogo().nome }}</dd>
          </div>
          <div>
            <dt>{{ 'auth.collegamento.riepilogo.cognome' | transloco }}</dt>
            <dd>{{ riepilogo().cognome }}</dd>
          </div>
          <div>
            <dt>{{ 'auth.collegamento.riepilogo.telefono' | transloco }}</dt>
            <dd>{{ riepilogo().telefono }}</dd>
          </div>
          <div>
            <dt>{{ 'auth.collegamento.riepilogo.email' | transloco }}</dt>
            <dd>{{ riepilogo().email || ('auth.collegamento.riepilogo.nonIndicato' | transloco) }}</dd>
          </div>
          <div>
            <dt>{{ 'auth.collegamento.riepilogo.messaggio' | transloco }}</dt>
            <dd class="testo-libero">{{ riepilogo().testo }}</dd>
          </div>
        </dl>
        <ion-button expand="block" color="primary" fill="solid" (click)="vai('riepilogo2')">
          {{ 'auth.collegamento.azioni.continua' | transloco }}
        </ion-button>
        <ion-button expand="block" color="primary" fill="outline" class="azione-secondaria" (click)="vai('segnalazione')">
          {{ 'auth.collegamento.azioni.modifica' | transloco }}
        </ion-button>
        <ion-button expand="block" color="primary" fill="clear" class="azione-link" (click)="chiudi('esci')">
          {{ 'auth.collegamento.azioni.esciSenzaScegliere' | transloco }}
        </ion-button>
      }

      <!-- S8: durante l'invio i pulsanti restano focalizzabili (aria-disabled, non disabled) e i click sono ignorati. -->
      @case ('riepilogo2') {
        <p id="collegamento-descrizione">{{ 'auth.collegamento.riepilogo2.testo' | transloco }}</p>
        <p>{{ 'auth.collegamento.riepilogo2.accesso' | transloco: {provider: provider()} }}</p>
        @if (erroreInvio(); as chiave) {
          <p class="errore" id="collegamento-errore-invio" tabindex="-1">{{ 'auth.collegamento.' + chiave | transloco }}</p>
        }
        @if (invioInCorso()) {
          <p class="progresso">
            <ion-spinner name="crescent" aria-hidden="true"></ion-spinner>
            <span>{{ 'auth.collegamento.inCorso.testo' | transloco }}</span>
          </p>
        }
        <ion-button expand="block" color="primary" fill="solid" (click)="invia()"
                    [attr.aria-disabled]="invioInCorso() ? 'true' : null"
                    [attr.aria-busy]="invioInCorso() ? 'true' : null">
          {{ 'auth.collegamento.azioni.invia' | transloco }}
        </ion-button>
        <ion-button expand="block" color="primary" fill="outline" class="azione-secondaria" (click)="vai('riepilogo1')"
                    [attr.aria-disabled]="invioInCorso() ? 'true' : null">
          {{ 'auth.collegamento.azioni.indietro' | transloco }}
        </ion-button>
        <ion-button expand="block" color="primary" fill="clear" class="azione-link" (click)="chiudi('esci')">
          {{ 'auth.collegamento.azioni.esciSenzaScegliere' | transloco }}
        </ion-button>
      }

      <!-- S9 -->
      @case ('inviata') {
        <p id="collegamento-descrizione">{{ 'auth.collegamento.inviata.testo' | transloco: {riferimento: riferimento()} }}</p>
        <p>{{ 'auth.collegamento.inviata.contatto' | transloco: {telefono: telefonoInviato()} }}</p>
        <p>{{ 'auth.collegamento.inviata.accesso' | transloco: {provider: provider()} }}</p>
        <ion-button expand="block" color="primary" fill="solid" (click)="chiudi('esci')">
          {{ 'auth.collegamento.azioni.esci' | transloco }}
        </ion-button>
      }

      <!-- S10 -->
      @case ('giaInviata') {
        <!-- Stato a colpo d'occhio: testo + icona, il colore non è l'unico segnale. -->
        <p class="stato-verifica">
          <ion-icon name="time-outline" aria-hidden="true"></ion-icon>
          <span>{{ 'auth.collegamento.giaInviata.stato' | transloco }}</span>
        </p>
        <p id="collegamento-descrizione">{{ 'auth.collegamento.giaInviata.testo' | transloco: {provider: provider()} }}</p>
        @if (riferimento()) {
          <p>
            @if (dataSegnalazione(); as data) {
              {{ 'auth.collegamento.giaInviata.riferimento' | transloco: {data: data, riferimento: riferimento()} }}
            } @else {
              {{ 'auth.collegamento.giaInviata.riferimentoSenzaData' | transloco: {riferimento: riferimento()} }}
            }
          </p>
        }
        <p>{{ 'auth.collegamento.giaInviata.contatto' | transloco }}</p>
        @if (statoRisposta()?.account) {
          <p>{{ 'auth.collegamento.giaInviata.ripensamento' | transloco }}</p>
          <ion-button expand="block" color="primary" fill="outline" class="azione-secondaria" (click)="vaiAConfermaDaSegnalazione()">
            {{ 'auth.collegamento.azioni.inRealtaMio' | transloco }}
          </ion-button>
        }
        <ion-button expand="block" color="primary" fill="solid" (click)="chiudi('esci')">
          {{ 'auth.collegamento.azioni.esci' | transloco }}
        </ion-button>
      }

      <!-- S11 -->
      @case ('sessioneScaduta') {
        <p id="collegamento-descrizione">{{ 'auth.collegamento.sessioneScaduta.testo' | transloco: {provider: provider()} }}</p>
        <ion-button expand="block" color="primary" fill="solid" (click)="chiudi('esci')">
          {{ 'auth.collegamento.azioni.tornaAccesso' | transloco }}
        </ion-button>
      }

      <!-- S12 -->
      @case ('nonDisponibile') {
        <p id="collegamento-descrizione">{{ 'auth.collegamento.nonDisponibile.testo' | transloco: {provider: provider()} }}</p>
        <ion-button expand="block" color="primary" fill="solid" (click)="chiudi('esci')">
          {{ 'auth.collegamento.azioni.esci' | transloco }}
        </ion-button>
      }
    }
  </div>
</ion-content>
